import $ from '../../../../../FrontendBundle/Resources/js/jquery';
import ResizeItemCommand from '../command/resizeItemCommand';
import DrillItem from '../item/drillItem';
import DropdownField from './dropdownField';

/**
 * @class DrillSizeField
 */
export default class DrillSizeField extends DropdownField {
    type = 'drillSize';
    supports = null;

    /**
     * Register click event on dropdown.
     *
     * @param {jQuery} dropdown
     */
    registerEventsForDropdown(dropdown) {
        dropdown.on('click', 'li a', (...args) => this.onChangeSize(...args));
    }

    /**
     * @param {Event} event
     */
    onChangeSize(event) {
        const target = $(event.target);
        const item = this.currentItem;
        const newSize = target.data('item');
        const sizes = item.defaultSizes;
        const canvas = this.editor.getCanvas();
        const history = canvas.getHistory();

        const command = new ResizeItemCommand(
            item,
            newSize,
            newSize,
        );

        item.set('snapIndex', sizes.indexOf(newSize));
        history.addAndExecuteCommand(command);

        event.preventDefault();
    }

    /**
     * Update text with item value.
     *
     * @param {ItemInterface} item
     */
    updateOptions(item) {
        const sizes = item.defaultSizes;
        const currentHeight = item.get('height');
        const options = [];

        sizes.forEach((size) => {
            options.push({
                key: size,
                value: size,
                active: size === currentHeight,
            });
        });

        this.setOptions(options);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item instanceof DrillItem;
    }
}
